<template>
  <div>
    <NuxtLayout>
      <NuxtPwaAssets />
      <NuxtPage />
      <FloatingInstallButton />
    </NuxtLayout>

    
  </div>
</template>

<script lang="ts" setup>
import '@/types/yup-locale-fr';

useHead({
  titleTemplate: title => title ? `${title} | Leadbook` : 'Leadbook',
});
</script>
